import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { changeActiveTab } from "app/store/nonCompliantPatient/slice/nonCompliantPatientSlice";
import { useGetLiveCallTasksQuery } from "app/store/liveCallTasks/api/liveCallTasksApi";
import { useSelector } from "react-redux";

const useNonCompliantPatientTabs = (tabStyles) => {
  const dispatch = useDispatch();
  const { shouldCountLiveCallTodoTasks } = useSelector(
    (state) => state.liveCallTasks
  );

  const tabs = [
    {
      label: "No Show Patients",
      value: "no-show-patients",
      style: tabStyles("no-show-patients"),
    },
    {
      label: "Non Enrolled Patients",
      value: "no-show-patients/non-enrolled-patients",
      style: tabStyles("no-show-patients/non-enrolled-patients"),
    },
    {
      label: "Live Call Tasks",
      value: "no-show-patients/live-call-tasks",
      style: tabStyles("no-show-patients/live-call-tasks"),
    },
  ];
  const navigate = useNavigate();

  const { data: liveCallTasks } = useGetLiveCallTasksQuery(
    {
      search: "",
      account: "all",
      shouldCountLiveCallTodoTasks,
    },
    { refetchOnMountOrArgChange: true }
  );

  const liveCallTodoTasksCount = liveCallTasks
    ?.find((item) => item.status === "todo")
    ?.tasks?.reduce((acc, task) => acc + (task.patients?.length || 0), 0);

  const onTabChange = (value) => {
    dispatch(changeActiveTab(value));
    navigate(`/${value}`);
  };

  return { tabs, liveCallTodoTasksCount, onTabChange };
};

export default useNonCompliantPatientTabs;
